import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogAwsDeployment() {
  return <BlogDetailPage slug="aws-deployment-strategies-for-laravel" />;
}